import {useEffect} from "react"
import {setTrack} from "./tracking";

export const useScrollDepthPaywall = (page) => {
  useEffect(() => {
    if (typeof window === 'undefined')
      return

    let maxDepth = 0

    const action = `scroll_depth_${page}`

    const handler = () => {
      const scrollTop = window.scrollY + window.innerHeight
      const docHeight = document.body.scrollHeight
      const depth = Math.ceil((scrollTop / docHeight) * 100)

      if (depth >= 25 && maxDepth < 25) {
        setTrack(action, {percent: 25})
        maxDepth = 25
      }

      if (depth >= 50 && maxDepth < 50) {
        setTrack(action, {percent: 50})
        maxDepth = 50
      }

      if (depth >= 75 && maxDepth < 75) {
        setTrack(action, {percent: 75})
        maxDepth = 75
      }

      if (depth >= 100 && maxDepth < 100) {
        setTrack(action, {percent: 100})
        maxDepth = 100
      }
    }

    window.addEventListener('scroll', handler, {passive: true})

    return () => {
      window.removeEventListener('scroll', handler)
    }
  }, [])
}